module.exports = __webpack_public_path__ + "static/media/Agri-Investor_Challenges_-_GBR_Care_14-03-2024-removebg-preview.25bd6edf.png";